<template>
  <div class="dashboard-nav-menu">
    <el-scrollbar
      class="nav-menu-scrollbar"
      style="width:100%;"
      inverse>
      <el-menu
        ref="menu"
        :value="getActiveNavMenuItemId"
        :unique-opened="true"
        background="nav-primary">

        <el-menu-item
          :disabled="isDisabled"
          @click="onItemClick"
          index="resources">
          <el-icon
            slot="icon"
            name="i-resources-o--32"/>
          <span slot="title">{{ $t('wrh-dashboard.nav-menu.item.resources') | uppercase }}</span>
        </el-menu-item>

        <el-menu-item
          :disabled="isDisabled"
          @click="onItemClick"
          index="BACKUPS">
          <el-icon
            slot="icon"
            name="i-clone-o--32"/>
          <span slot="title">{{ $t('wrh-dashboard.nav-menu.item.backups') | uppercase }}</span>
        </el-menu-item>

        <el-menu-item
          :disabled="isDisabled"
          @click="onItemClick"
          index="ARCHIVES">
          <el-icon
            slot="icon"
            name="i-archive-o--32"/>
          <span slot="title">{{ $t('wrh-dashboard.nav-menu.item.archives') | uppercase }}</span>
        </el-menu-item>

        <el-menu-item
          :disabled="isDisabled"
          @click="onItemClick"
          index="SYNC">
          <el-icon
            slot="icon"
            name="i-refresh-scan-ab--32"/>
          <span slot="title">{{ $t('wrh-dashboard.nav-menu.item.sync') | uppercase }}</span>
        </el-menu-item>

        <!--        <el-menu-item-->
        <!--          :disabled="isDisabled"-->
        <!--          @click="onItemClick"-->
        <!--          index="MOBILE">-->
        <!--          <el-icon-->
        <!--            slot="icon"-->
        <!--            name="i-mobile-o&#45;&#45;32"/>-->
        <!--          <span slot="title">{{ $t('wrh-dashboard.nav-menu.item.mobile') | uppercase }}</span>-->
        <!--        </el-menu-item>-->

        <el-menu-item
          :disabled="isDisabled"
          @click="onItemClick"
          index="shared">
          <el-icon
            slot="icon"
            name="i-share-o--32"/>
          <span slot="title">{{ $t('wrh-dashboard.nav-menu.item.shared') | uppercase }}</span>
        </el-menu-item>

        <el-menu-item
          @click="onItemClick"
          index="account">
          <el-icon
            slot="icon"
            name="i-user-o--32"/>
          <span slot="title">{{ $t('wrh-dashboard.nav-menu.item.account') | uppercase }}</span>
        </el-menu-item>

      </el-menu>
    </el-scrollbar>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';

const { mapGetters } = createNamespacedHelpers('wrh-dashboard');

export default {
  name: 'DashboardNavMenu',
  data() {
    return {
    };
  },
  computed: {
    ...mapGetters([
      'getActiveNavMenuItemId',
      'getUserSubscriptionType'
    ]),
    isDisabled() {
      return this.getUserSubscriptionType !== 'ACTIVE';
    }
  },
  methods: {
    onItemClick(menuItem) {
      if (!menuItem.disabled) {
        const action = this.getMenuEventActionName(menuItem.index);

        this.$gtm.push({
          event: 'Acronis',
          eventCategory: 'WR_menu',
          eventAction: action,
          eventLabel: ''
        });

        this.handleSelect(menuItem.index);
      }
    },
    handleSelect(key) {
      this.$emit('navMenuItemSelected', {
        id: key
      });
    },
    getMenuEventActionName(menuIdx) {
      if (menuIdx === 'resources') {
        return 'Resources_on_FD';
      } else if (menuIdx === 'shared') {
        return 'Sharing';
      } else if (menuIdx === 'account') {
        return 'Account';
      } else if (menuIdx === 'BACKUPS') {
        return 'Backup';
      } else if (menuIdx === 'ARCHIVES') {
        return 'Archive';
      } else if (menuIdx === 'SYNC') {
        return 'Sync';
      } else if (menuIdx === 'MOBILE') {
        return 'Mobile';
      }

      console.log('Undefined menu index', menuIdx);
      return 'Undefined';
    }
  }
};
</script>


<style lang="scss" scoped>

</style>
